export const EXPERTS_GET_STATUSES_LIST = 'EXPERTS_GET_STATUSES_LIST';
export const EXPERTS_GET_STATUSES_LIST_SUCCESS = 'EXPERTS_GET_STATUSES_LIST_SUCCESS';
export const EXPERTS_GET_STATUSES_LIST_ERROR = 'EXPERTS_GET_STATUSES_LIST_ERROR';